// src/pages/MultimediaAndDtpServices.js
import React from 'react'
import { NavLink } from 'react-router-dom'

const MultimediaAndDtpServices = () => (
  <>
    {/* Breadcrumb */}
    <div
      className="optech-breadcrumb"
      style={{ backgroundImage: 'url(/assets/images/breadcrumb/breadcrumb.png)' }}
    >
      <div className="container">
        <h1 className="post__title">Multimedia &amp; DTP Services</h1>
        <nav className="breadcrumbs">
          <ul>
            <li><NavLink to="/service">AI Service</NavLink></li>
            <li aria-current="page">Multimedia &amp; DTP Services</li>
          </ul>
        </nav>
        <p className="text-white pt-5">
          Robust communication isn’t just about words—it also involves compelling visuals
          and well-structured designs. R A Inc’s multimedia and Desktop Publishing (DTP)
          offerings marry creative elements with clarity, transforming content for print,
          digital, and interactive channels.
        </p>
      </div>
    </div>

    {/* Main Content */}
    <section className="section optech-section-padding">
      <div className="container">
        <div className="row">
          {/* Left column */}
          <div className="col-lg-8">
            <div className="optech-service-details-wrap">
              <img
                data-aos="fade-up"
                data-aos-duration="800"
                src="/assets/images/service/multimedia-dtp.jpg"
                alt="Multimedia & Desktop Publishing"
              />

              {/* Overview */}
              <div className="optech-service-details-item">
                <h3>Overview</h3>
                <p>
                  Multimedia engagements can span video-based training modules, motion graphics
                  for ads, or interactive tutorials for onboarding new staff. In parallel, DTP
                  ensures the text and images in your documents flow seamlessly across pages,
                  preserving readability and aesthetics. Combining these skills, we deliver
                  finalized assets that captivate attention and conform to brand guidelines,
                  regardless of language or target audience.
                </p>
              </div>

              {/* Key Solutions */}
              <div className="optech-service-details-item">
                <h3>Key Solutions</h3>
                <div className="optech-icon-list">
                  <ul>
                    <li><i className="ri-check-line" /><strong> Motion Graphics:</strong> Animating presentations and commercials to increase viewer retention.</li>
                    <li><i className="ri-check-line" /><strong> Image Refinement:</strong> Polishing and standardizing images for uniform branding.</li>
                    <li><i className="ri-check-line" /><strong> Mobile eLearning:</strong> Designing modules compatible with smartphones and tablets.</li>
                    <li><i className="ri-check-line" /><strong> Photo Restoration:</strong> Recovering or revitalizing worn or historical images.</li>
                    <li><i className="ri-check-line" /><strong> Kindle Conversions:</strong> Transforming documents into reader-friendly ebook formats.</li>
                    <li><i className="ri-check-line" /><strong> Professional Storyline Translations:</strong> Integrating translations into interactive modules without losing context.</li>
                  </ul>
                </div>
              </div>

              {/* Sample Applications Table */}
              <div className="optech-service-details-item">
                <h3>Sample Multimedia &amp; DTP Applications</h3>
                <table className="table table-bordered">
                  <thead>
                    <tr><th>Type</th><th>Example</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>Corporate Presentation</td><td>Engaging slides with dynamic charts and consistent branding</td></tr>
                    <tr><td>Educational Module</td><td>Quizzes, embedded media, localized voice-overs</td></tr>
                    <tr><td>Marketing Flyer</td><td>Multilingual text, high-quality graphics, contemporary layouts</td></tr>
                  </tbody>
                </table>
              </div>

              {/* Highlights */}
              <div className="optech-service-details-item">
                <h3>Highlights</h3>
                <ul className="list-unstyled">
                  <li><i className="ri-check-line" /> Our translators and designers collaborate to maintain textual and visual alignment.</li>
                  <li><i className="ri-check-line" /> We provide end-to-end handling of file types, from InDesign to custom interactive formats.</li>
                  <li><i className="ri-check-line" /> Detailed attention to typography, color matching, and cultural nuances ensures global consistency.</li>
                </ul>
              </div>

              {/* Conclusion */}
              <div className="optech-service-details-item">
                <h3>Conclusion</h3>
                <p>
                  Our expertise in multimedia and DTP grants you access to content that’s appealing,
                  coherent, and optimized for varied media channels. Whether you’re publishing educational
                  resources or producing a new product campaign, R A Inc merges creative flair with accuracy,
                  delivering projects that stand out in both local and international arenas.
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="col-lg-4">
            <div className="optech-service-sidebar">
            <div className="optech-service-menu">
  <ul>
    {[
      { name: 'Multimedia & DTP Services',         slug: '/multimedia-and-dtp-services' },
      { name: 'Audio & Video Transcription',       slug: '/audio-and-video-transcription' },
      { name: 'Desktop Publishing Services',       slug: '/desktop-publishing-services' },
      { name: 'Subtitle Services',                 slug: '/subtitling' },
      { name: 'Multilingual Desktop Publishing',   slug: '/multilingual-desktop-publishing' },  // ← comma here
      { name: 'Multimedia & DTP Tools',            slug: '/multimedia-and-dtp-tools' }
    ].map(service => (
      <li key={service.slug}>
        <NavLink to={service.slug}>
          {service.name} <i className="ri-arrow-right-up-line" />
        </NavLink>
      </li>
    ))}
  </ul>
</div>

              <div
                className="optech-service-contact"
                data-aos="fade-up"
                data-aos-duration="800"
                style={{ backgroundImage: 'url(/assets/images/service/bg.png)' }}
              >
                <div className="optech-service-contact-icon">
                  <img src="/assets/images/service/icon.svg" alt="" />
                </div>
                <h3>Need Multimedia Support?</h3>
                <p>
                  Collaborate with our creative team for compelling visuals, precise formatting, and
                  culturally resonant designs across languages.
                </p>
                <NavLink className="optech-default-btn" data-text="Get in Touch" to="/contact-us">
                  <span className="btn-wraper">Get in Touch</span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Call-to-Action */}
    <section
      className="section bg-cover optech-section-padding"
      style={{ backgroundImage: 'url(/assets/images/cta/cta-bg2.png)' }}
    >
      <div className="container">
        <div className="optech-cta-wrap">
          <div className="optech-cta-content center">
            <h2>Let's Translate Your Vision Into Every Language</h2>
            <p>
              Whether you're expanding your business internationally or need multilingual content for local markets,
              we provide solutions tailored to your goals, audience, and tone.
            </p>
            <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
              <NavLink className="optech-default-btn" data-text="Let’s Start a Project" to="/contact-us">
                <span className="btn-wraper">Let’s Start a Project</span>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
)

export default MultimediaAndDtpServices